import { IExperiment } from '../api/experiments';

export const DEAL_RENT_ACTION_TITLE = 'offer_deal_rent_action_title';

export const isDealRentActionTitle = (experiments: IExperiment[]): boolean => {
  const experiment = experiments.find(exp => exp.name === DEAL_RENT_ACTION_TITLE);

  return Boolean(experiment && experiment.abGroup);
};
